import {Component, Input} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ScheduleTypeDto} from "../../../../core/interfaces/core.types";
import {ScheduleAppointmentTypeComponent} from "../schedule-appointment-type/schedule-appointment-type.component";
import {InteractionService} from "../../../../ci/service/interaction.service";
import {InteractionApiService} from "../../../../ci/api/interaction-api.service";

@Component({
  selector: 'v-card',
  templateUrl: 'v-card.component.html',
})
export class VCardComponent extends CoreComponent {


  @Input() scheduleType: ScheduleTypeDto | undefined;

  constructor(protected scheduledAppointmentService: ScheduleAppointmentTypeComponent, protected interactionService: InteractionApiService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {

    this.refreshComponent();
  }

  refreshComponent() {


    this.initialized = true;
  }

  get qrCodeImageSrc(): string | null {
    if (this.scheduleType?.qrDocument?.dataBase64 && this.scheduleType.qrDocument.mimeType) {
      return `data:${this.scheduleType.qrDocument.mimeType};base64,${this.scheduleType.qrDocument.dataBase64}`;
    }
    return null;
  }


}
